import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { MarketoLinkedService } from 'app/model/linkedservice/marketo.linkedservice';
import { MarketoCopySource } from 'app/model/pipeline/copysource/marketo.copysource';
import { useEncryptedEndpointsRadioSwitch } from './linked-service-shared-fields';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const marketoMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(MarketoLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Marketo_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-marketo'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(MarketoCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'endpoint',
            label: stringResources.ModelName_Endpoint,
            required: true,
            placeholder: stringResources.Marketo_Endpoint_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'clientId',
            label: stringResources.ModelName_ClientId,
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'clientSecret',
            label: stringResources.ModelName_ClientSecret,
            child: {
                type: 'password',
                required: true,
                label: stringResources.ModelName_ClientSecret,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Marketo_DisplayText),
                stringResources.ModelName_ClientSecret)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
